module.exports = __webpack_public_path__ + "media/images/icons/country_flags/im-ef5d541adb911c801807952da1ebfdb8.svg";